import { render } from "./InventoryReport.vue?vue&type=template&id=3e0337c1"
import script from "./InventoryReport.vue?vue&type=script&lang=js"
export * from "./InventoryReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__